import PropTypes from "prop-types";
import React, { useContext } from "react";
import Header from "./header";
import Footer from "./footer";
import SiteMetaContext from "../../../contexts/SiteMetaContext";
import * as theme3Styles from "../scss/theme3.module.scss";

function Layout({ children }) {
  const siteData = useContext(SiteMetaContext);

  const {
    remarso: {
      domainByURL: {
        website: {
          theme: colorTheme = "theme-default",
          setting: display_settings,
        },
      },
    },
  } = siteData;

  // let themeColor = `${theme3Styles.themeGreen}`;
  // if (colorTheme == "theme-blue") {
  //   themeColor = `${theme3Styles.themeBlue}`;
  // } else if (colorTheme == "theme-white") {
  //   themeColor = `${theme3Styles.themeWhite}`;
  // } else if (colorTheme == "theme-orange") {
  //   themeColor = `${theme3Styles.themeOrange}`;
  // } else if (colorTheme == "theme-red") {
  //   themeColor = `${theme3Styles.themeRed}`;
  // }

  let themeColor = `${theme3Styles.themeDefault}`;
  if (colorTheme == "theme-blue") {
    themeColor = `${theme3Styles.themeBlue}`;
  } else if (colorTheme == "theme-white") {
    themeColor = `${theme3Styles.themeWhite}`;
  } else if (colorTheme == "theme-red") {
    themeColor = `${theme3Styles.themeRed}`;
  } else if (colorTheme == "theme-orange") {
    themeColor = `${theme3Styles.themeOrange}`;
  } else if (colorTheme == "theme-yellow") {
    themeColor = `${theme3Styles.themeYellow}`;
  } else if (colorTheme == "theme-green") {
    themeColor = `${theme3Styles.themeGreen}`;
  } else if (colorTheme == "theme-purple") {
    themeColor = `${theme3Styles.themePurple}`;
  }

  const { display_footer } = display_settings;

  const wrapperClass = `flex flex-col min-h-screen font-sans text-gray-900 ${themeColor}`;

  return (
    <div className={wrapperClass}>
      <Header />
      <main className="">{children}</main>
      {(() => {
        if (display_footer) {
          return <Footer />;
        }
      })()}
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
